var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.600098 6.37461C0.600098 4.8268 1.87313 3.59961 3.40919 3.59961H20.591C22.1271 3.59961 23.4001 4.8268 23.4001 6.37461V17.6246C23.4001 19.1724 22.1271 20.3996 20.591 20.3996H3.40919C1.87313 20.3996 0.600098 19.1724 0.600098 17.6246V6.37461ZM2.4001 6.37461C2.4001 5.85135 2.83653 5.39961 3.40919 5.39961H20.591C21.1637 5.39961 21.6001 5.85135 21.6001 6.37461V9.59961H2.4001V6.37461ZM21.6001 11.3996V17.6246C21.6001 18.1479 21.1637 18.5996 20.591 18.5996H3.40919C2.83653 18.5996 2.4001 18.1479 2.4001 17.6246V11.3996H21.6001Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.b3e4dc5c9edd70975a0d39782b125246.svg";
export { ForwardRef as ReactComponent };